<template  >
<v-layout column fill-height="">
    <not-toolbar-sub :not="not"></not-toolbar-sub> 
    <!-- //page -->
    <v-container grid-list-xl>
        <v-layout column class="ma-7">
            <mbs-page-tab
                :items="page_tabs" />  
            <v-toolbar color="primary" dark="" flat tile=""  >
                <v-toolbar-title>
                    MANAGE USERS
                </v-toolbar-title>
                <v-spacer></v-spacer> 
                <v-btn @click="addUser()" color="white" outlined="" rounded="" class="mr-2"><v-icon size="18" class="pr-1">mdi-plus-thick</v-icon>Add User</v-btn>
                <v-menu  bottom left 
                    v-model="menuUsers"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                    <v-btn
                        dark outlined="" rounded=""
                        icon
                        v-on="on" >
                        <v-icon>mdi-tune</v-icon>
                    </v-btn>
                    </template>
    
                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                CUSTOMIZE TABLE
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuUsers=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_user" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeader_user,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuUsers = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text>
                        
                    </v-card> 
                </v-menu>
                <v-menu bottom left >
                    <template v-slot:activator="{ on }">
                    <v-btn 
                        dark
                        icon
                        v-on="on" >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>
    
                    <v-list> 
                        <v-list-item  @click="menuUsers=true" >
                            <v-list-item-title>Customize Table</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="addUser()" >
                            <v-list-item-title>Add User</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item  @click="onExcelSelect()" >
                            <v-list-item-title>Import Users from Excel</v-list-item-title>
                        </v-list-item> -->
                        <!-- <v-list-item   >
                            <v-list-item-title>Export Users</v-list-item-title>
                        </v-list-item> 
                        <v-list-item  @click="deleteAllCentes()" >
                            <v-list-item-title>Delete All Users</v-list-item-title>
                        </v-list-item> -->
                    </v-list>
                </v-menu> 
            </v-toolbar>
            
            <not-page-spinner 
                :notShow="true" 
                :not="not"
                v-if="!page_show"/>
    
            <div v-else  >
    
                <v-card v-if="uds" class="pa-2" tile="">
                    <!-- load page -->
                    <not-page-spinner 
                        :notShow="true" 
                        :not="not"
                        v-if="!page_show_users"/> 
                    <div v-else-if="JOINED_uds">
                        <v-card-title>
                            USERS
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                            
                        </v-card-title>
                        <!-- //CHECK USERS READ ACCESS -->
    
                        <div v-if="accessUsers('read')">
                            <v-data-table
                                :headers="headers('user')"
                                :items="JOINED_uds"
                                :search="search" >
    
                                <template v-slot:top>
                                    
                                </template>
                                <template v-slot:item.action="{ item }" > 
                                    
                                    <v-hover v-slot:default="{hover}" class="ma-1">
                                        <v-avatar tile color="primary" class="pa-1">
                                            <v-icon size="18" dark @click="editUser(item)" :class="hover?'white':''" :color="hover?'primary':'white'">mdi-pencil</v-icon>
                                        </v-avatar>
                                    </v-hover>
                                    <v-hover v-slot:default="{hover}" class="ma-1">
                                        <v-avatar tile color="accent" class="pa-1" >
                                            <v-icon size="25" dark @click="addLocation(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-map-marker-radius</v-icon>
                                        </v-avatar>
                                    </v-hover>
                                    <v-hover v-slot:default="{hover}" class="ma-1">
                                        <v-avatar tile color="red" class="pa-1" >
                                            <v-icon size="18" dark @click="deleteUser(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-close</v-icon>
                                        </v-avatar>
                                    </v-hover> 
                                </template>
                                <template v-slot:no-data>
                                    <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                                </template>
                            </v-data-table>  
                        </div>
                        <div v-else>
                            <v-layout  justify-center="" align-center="" class=" primary lighten-4 mx-2 pa-5 ">
                                <v-icon size="50" color="primary">mdi-shield-account</v-icon>
                                <div>You have no users read permission</div> 
                            </v-layout> 
                        </div>
                    </div>
                </v-card> 
            </div>  
        </v-layout>
    </v-container>


    <!-- create -->
    <v-dialog v-model="dialog_add_user" persistent max-width="800px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">CREATE NEW USER</span>
                <v-spacer></v-spacer>
                <!-- <v-btn color="white" outlined="" rounded="" class="ml-2"><v-icon size="" class="pr-1">mdi-file-excel-outline</v-icon> EXCEL</v-btn> -->
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submitted()">
                        <v-layout row wrap class="pa-1">   
                            <!-- Title -->
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="email"
                                    filled=""
                                    v-model="input.email" 
                                    label="Email"/>  
                            </v-flex> 
                            <v-flex xs6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.surname" 
                                    label="Surname"/>  
                            </v-flex>  
                            <v-flex xs6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.names" 
                                    label="Names"/>  
                            </v-flex>  
                            
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="number"
                                    filled=""
                                    v-model="input.phone" 
                                    label="Phone Number"/>  
                            </v-flex>   
                            <v-flex xs12 sm6>
                                <v-text-field  
                                    required
                                    type="password"
                                    filled=""
                                    v-model="input.password" 
                                    label="Password" />  
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  
                                    required
                                    type="password"
                                    filled=""
                                    v-model="input.confirm_password" 
                                    label="Cnfirm Password" />  
                            </v-flex> 
                            <!-- user group --> 
                            <v-flex xs12 >
                               <v-select
                                    v-model="input.user_group_code" 
                                    filled
                                    :items="not.selectorNames(userGroups)"
                                    label="Select User Group"
                                    ></v-select>
                            </v-flex> 
                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_add_user=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input_loading" dark="" type="submit">Create User</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click save button to create new user</small>
            </v-card-text> 
        </v-card>
    </v-dialog>

    <!-- edit -->
    <v-dialog v-model="dialog_edit_user" persistent max-width="800px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">EDIT USER ACCOUNT</span>
                <v-spacer></v-spacer> 
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submittedEdit()">
                        <v-layout row wrap class="pa-1">   
                            <!-- Title -->
                             <v-flex xs12> 
                                <v-text-field 
                                    required  disabled=""
                                    type="email"
                                    filled=""
                                    v-model="input.email" 
                                    label="Email"/>  
                            </v-flex> 
                            <v-flex xs6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.surname" 
                                    label="Surname"/>  
                            </v-flex>  
                            <v-flex xs6> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled=""
                                    v-model="input.names" 
                                    label="Names"/>  
                            </v-flex>     
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="number"
                                    filled="" 
                                    v-model="input.phone" 
                                    label="Phone Number"/>  
                            </v-flex>  
                            <v-flex xs12 sm6>
                                <v-text-field  disabled
                                    type="password"
                                    filled="" 
                                    v-model="input.password" 
                                    label="New Password" />  
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  disabled
                                    type="password"
                                    filled=""  
                                    v-model="input.confirm_password" 
                                    label="Cnfirm Password" />  
                            </v-flex> 
                             <!-- user group --> 
                            <v-flex xs12 >
                               <v-select
                                    v-model="input.user_group_code" 
                                    filled
                                    :items="not.selectorNames(userGroups)"
                                    label="Select User Group"
                                    ></v-select>
                            </v-flex> 
                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_edit_user=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input_loading" dark="" type="submit">Save Changes</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click Update button to save changes</small>
            </v-card-text> 
        </v-card>
    </v-dialog>

    <!-- add location -->
    <v-dialog v-model="dialog_add_location" persistent max-width="1200px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">USER LOCATION</span>
                <v-spacer></v-spacer>
                <v-btn v-if="!isAutoCode(inputCode,'location')" @click="setAutoCode('location')" color="white" outlined="" rounded="" class="ml-2">AUTO GENERATE CODE</v-btn>
                <!-- <v-btn @click="addExcelResuts()" color="white" outlined="" rounded="" class="ml-2"><v-icon size="" class="pr-1">mdi-file-excel-outline</v-icon> EXCEL</v-btn> -->

                <v-btn class="ml-2" color="white" icon @click="dialog_add_location=false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>  
                    <form id="itemDetailForm" @submit.prevent="submiteLocation()" autocomplete="false">
                        <v-layout row wrap class="pa-1"> 
                            <v-flex xs12 md6> 
                                <v-text-field 
                                    required  
                                    type="number"
                                    filled=""
                                    v-model="inputCode" 
                                    label="Code"/>  
                            </v-flex>   
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.region_code" 
                                    filled 
                                    :append-icon="!activateField('region')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('region')"
                                    :items="not.selectorNames(regions)"
                                    label="Select Region"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.district_code" 
                                    filled
                                    :append-icon="!activateField('district')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('district')"
                                    :items="not.selectorNames(FT_districts)"
                                    label="Select District"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.constituency_code" 
                                    filled
                                    :append-icon="!activateField('constituency')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('constituency')"
                                    :items="not.selectorNames(FT_constituencies)"
                                    label="Select Constituency"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.ward_code" 
                                    filled
                                    :append-icon="!activateField('ward')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('ward')"
                                    :items="not.selectorNames(FT_wards)"
                                    label="Select Wards"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.centre_code" 
                                    filled
                                    :append-icon="!activateField('centre')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('centre')"
                                    :items="not.selectorNames(FT_centres)"
                                    label="Select Centres"/>
                            </v-flex>  
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_add_location=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input.loading" dark="" type="submit">ADD LOCATION</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container> 
                <div v-if="JOINED_locationUS(input.observer?input.observer.key:null)">
                        <v-card color="b2">
                            <v-card-title primary-title>
                                Location List
                            </v-card-title>
                            <v-data-table
                                :headers="headers('location')"
                                :items="JOINED_locationUS(input.observer?input.observer.key:null)"
                                :search="search" >

                                <template v-slot:top> 
                                
                                </template>
                                <template v-slot:item.action="{ item }" >  
                                    <v-hover v-slot:default="{hover}" class="ma-1">
                                        <v-avatar tile color="red" class="pa-1" >
                                            <v-icon size="18" dark @click="deleteLocation(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-close</v-icon>
                                        </v-avatar>
                                    </v-hover> 
                                </template>
                                <template v-slot:no-data>
                                    <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                        <v-icon>warning</v-icon>
                                        Empty
                                    </v-layout>
                                </template>
                            </v-data-table>  
                        </v-card>
                    </div>
                    <v-layout v-else row wrap class="pa-5 primary lighten-4" justify-center="" align-center="">
                        <v-icon class="mr-2">mdi-alert-circle</v-icon> No location assigned to this observer
                    </v-layout>
            </v-card-text> 
      </v-card>
    </v-dialog> 
</v-layout>
</template>

<script> 
import DATA from '../../../plugins/DATA';
    
   let pageName = 'User'
   let ACTION_TIME = 10
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
            page_show_users: false,

            menuUsers:false,
            dialog_add_user:false,
            dialog_edit_user:false,
            dialog_add_location:false,
            inputCode:null,
            input:{},
            input_loading:false,
            inputCode:null,
            search: '', 
            xHeader_user:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Name",show:true},  

                {id:0,name:"Email",show:true}, 
                {id:0,name:"User Group",show:true},  
                {id:0,name:"User Group Code",show:false}, 
 
                {id:0,name:"Added By",show:false}, 
                {id:0,name:"Added At",show:false}, 
                {id:0,name:"Updated At",show:false},
                {id:26,name:"ACTION",show:true},  
            ],
            page_tabs:[
                    {name:"Users",link:"/settings/users"},
                    {name:"User Groups",link:"/settings/user-groups"},
                    {name:"Permissions",link:"/settings/permissions"},
                ]
            
             
        }), 
        created(){
            // this.EventBus.$on('notYesDialog', this.notYesDialog); 
            this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
        },
        mounted() {   3
            this.pageLoad(1000)
        },
        computed:{ 
            accessUsers(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("users") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("users") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("users") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("users") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            usr(){
                return this.not.usr
            },
            uds(){
                return this.not.uds
            },
            ud(){
                return this.not.ud
            },

            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },


            regions(){
                return this.$store.getters.getRegions
            }, 
            districts(){
                return this.$store.getters.getDistricts
            }, 
            constituencies(){
                return this.$store.getters.getConstituencies
            }, 
            wards(){
                return this.$store.getters.getWards
            }, 
            centres(){
                return this.$store.getters.getCentres
            }, 
            FT_districts(){
                let districts = this.districts
                let input_ = this.input.region_code
                if (!districts) {return null}
                if (!input_) {return null}
                let region_code = this.not.selectorNamesCode(this.regions,input_) 
                let fts = districts.filter(ds=>{
                    return ds.region_code === region_code
                })
                return fts
            }, 
            FT_constituencies(){
                let constituencies = this.constituencies
                let input_ = this.input.district_code
                if (!constituencies) {return null}
                if (!input_) {return null}
                let district_code = this.not.selectorNamesCode(this.districts,input_ ) 
                let fts = constituencies.filter(item=>{
                    return item.district_code === district_code
                })
                return fts
            }, 
            FT_wards(){
                let wards = this.wards
                let input_ = this.input.constituency_code
                if (!wards) {return null}
                if (!input_) {return null}
                let constituency_code = this.not.selectorNamesCode(this.constituencies,input_) 
                let fts  = wards.filter(item=>{
                    return item.constituency_code === constituency_code
                })
                return fts
            },
            FT_centres(){
                let centres = this.centres
                let input_ = this.input.ward_code
                if (!centres) {return null}
                if (!input_) {return null}
                let ward_code = this.not.selectorNamesCode(this.wards,input_) 
                let fts  = centres.filter(item=>{
                    return item.ward_code === ward_code
                })
                return fts
            },
            userLocation(){
                return this.$store.getters.getUserLocation
            },

            locationForUS(){
                return key=>{
                    // return this.$store.getters.getLocationForUser(key) 
                    return null
                }
            },
            JOINED_locationUS(){
                return key=>{
                    let location = this.locationForUS(key)
                    let join = this.not.JOIN_USER_LOCATION(location) 
                    return join 
                }
            },


            userGroups(){
                return this.$store.getters.getUserGroups
            }, 
            JOINED_uds(){
                let uds = this.uds
                let JOIN_UDS = this.not.JOIN_UDS(uds)
                return JOIN_UDS 
            }
        },
        //------------methods---------------
        methods: { 
            clicked(){},
           
            addUser(){
                let p = this.accessUsers("write")
                if (!p) {
                   this.MBS.actions.dialog(null,true,false,"PERMISSION DENIED",
                   "Sorry, you have no users write permission. Contact system admin for more info.","OK") 
                } else {
                    this.input = {}
                    this.dialog_add_user = true
                }
                
            },
            editUser(user){
                let p = this.accessUsers("edit")  
                if (!p) {
                   this.MBS.actions.dialog(null,true,false,"PERMISSION DENIED","Sorry, you have no users edit permission. Contact system admin for more info.","OK") 
                } else {
                    this.input = {}
                    this.input.uid = user.uid
                    this.input.email = user.email
                    this.input.name = user.name
                    this.input.surname = user.surname
                    this.input.names = user.names
                    this.input.phone = user.phone
                    this.input.password = user.password
                    this.input.confirm_password = user.password
                    this.input.user_group_code = this.not.selectorCodeName(this.userGroups, user.user_group_code)
                    this.dialog_edit_user = true
                }  
            },
            submitted(){
                if (!this.input.user_group_code) {
                    this.MBS.actions.dialog(null,true,true,"USER GROUP ERROR","Make sure you select user group and try again","OK")
                }else if (this.input.password!==this.input.confirm_password) {
                    this.MBS.actions.dialog(null,true,true,"PASSWORD ERROR","Password mismatch. please,check and try again","OK")
                }else if (this.MBS.actions.SIZE(this.input.password)<7) {
                    this.MBS.actions.dialog(null,true,true,"PASSWORD ERROR","Password, mast at least 8 characters or numbers.","OK")
                }else{ 
                    this.input.user_group_code = this.not.selectorNamesCode(this.userGroups,this.input.user_group_code) 
                    let mbs_text = this.MBS.text.item_action("User","Create")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:pageName+"=CREATE-USER",
                            details:{
                                surname:this.input.surname,
                                names:this.input.names,
                                email:this.input.email,
                                phone:this.input.phone,
                                user_group_code:this.input.user_group_code,
                                password:this.input.password,
                            }
                        }
                    })
                }
            },
            submittedEdit(){
                if (!this.input.user_group_code) {
                   this.MBS.actions.dialog(null,true,true,"USER GROUP ERROR","Make sure you select user group and try again","OK")
                }else{
                    this.input.user_group_code = this.not.selectorNamesCode(this.userGroups,this.input.user_group_code)  

                    let mbs_text = this.MBS.text.item_action("User","Edit")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:pageName+"=EDIT-USER",
                            user:this.input
                        }
                    })
                    console.log(this.input);
                } 
            },
            deleteUser(user){ 
                let ud = this.ud
                let p = this.accessUsers("delete")
                if (!p) {
                   this.MBS.actions.dialog(null,true,false,"PERMISSION DENIED","Sorry, you have no users delete permission. Contact system admin for more info.","OK") 
                } else {
                    if (user.email==="admin@masoathu.com") {
                        this.MBS.actions.dialog(null,true,true,"PERMISSION DENIED",'You can not delete super admin. For more info contact admin.','OK') 
                    }else if (ud.uid===user.uid) { 
                        let mbs_text = this.MBS.text.item_action("User Account","Delete")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" If you delete your account you will be logged out",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:pageName+"=CONFIRM-DELETE-USER",
                                user:{...user,signout:true} 
                            }
                        })
                    } else {
                        let mbs_text = this.MBS.text.item_action("User Account","Delete")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:pageName+"=CONFIRM-DELETE-USER",
                                user:user 
                            }
                        })
                    }
                } 
                
            },

            addLocation(user){
                let p = this.accessUsers("edit")
                if (!p) {
                   this.MBS.actions.dialog(null,true,false,"PERMISSION DENIED","Sorry, you have no users write permission. Contact system admin for more info.","OK") 
                } else {
                    this.inputCode = null
                    this.input = {}
                    this.input.user= user
                    this.dialog_add_location = true
                    console.log( this.input); 
                } 
            },
            activateField(field){
                let submitLevel = this.input_submitLevel
                let region_code = this.input.region_code
                let district_code = this.input.district_code
                let constituency_code = this.input.constituency_code
                let ward_code = this.input.ward_code
                if (!field) {
                    return false
                } 

                //check selected
                if (!region_code) {
                    if (field==='district') {
                        return false
                    }
                    if (field==='constituency') {
                        return false
                    }
                    if (field==='ward') {
                        return false
                    }
                    if (field==='centre') {
                        return false
                    }
                }
                if (!district_code) { 
                    if (field==='constituency') {
                        return false
                    }
                    if (field==='ward') {
                        return false
                    }
                    if (field==='centre') {
                        return false
                    }
                }
                if (!constituency_code) {  
                    if (field==='ward') {
                        return false
                    }
                    if (field==='centre') {
                        return false
                    }
                }
                if (!ward_code) {  
                    if (field==='centre') {
                        return false
                    }
                } 
                return true
            },
            submiteLocation(){
                //convert code to int
                let code = this.inputCode*1 
                let array = this.observerLocation

                //check code
                if (code === 0) {
                    this.MBS.actions.dialog(null,true,true,"ERROR CODE",'Code can not be zero (0). Try another code or click AUTO GENERATE CODE BUTTON to generate a uniquecode.','CANCEL',"AUTO GENERATE CODE",{
                        code:pageName+"=AUTO-SET-CODE",
                        data:array
                    }) 
                    return
                }
                if (this.not.CODE_CHECK(array,code)) {
                    this.MBS.actions.dialog(null,true,true,"ERROR CODE",'This Code has already been used. Try another code or click AUTO GENERATE CODE BUTTON to generate a uniquecode.','CANCEL',"AUTO GENERATE CODE",{
                        code:pageName+"=AUTO-SET-CODE",
                        data:array
                    }) 
                    return
                } 
                console.log(this.input);
                

                if (!this.input) {
                    this.MBS.actions.dialog(null,true,true,"ERROR","Make sure you filled the form and try again","OK")
                }else{
                    
                    this.input.code = code
                    this.input.region_code = this.not.selectorNamesCode(this.regions,this.input.region_code) 
                    this.input.district_code = this.not.selectorNamesCode(this.districts,this.input.district_code) 
                    this.input.constituency_code = this.not.selectorNamesCode(this.constituencies,this.input.constituency_code) 
                    this.input.ward_code = this.not.selectorNamesCode(this.wards,this.input.ward_code) 
                    this.input.centre_code = this.not.selectorNamesCode(this.centres,this.input.centre_code)   
                    this.MBS.actions.dialog(null,true,true,"ADD USER LOCATION",'Are you sure you want to add this user location','CANCEL',"ADD",{
                        code:pageName+"=ADD-USER-LOCATION",
                        details:{
                            ...this.input,
                            user_key:this.input.user.key,
                            user_code:this.input.user.code,
                            user:null
                        }
                    }) 

                    console.log(this.input);
                    
                }
            },
            deleteLocation(location){
                console.log(location);
                
                let p = this.accessUsers("edit") 
                if (!p) {
                   this.MBS.actions.dialog(null,true,false,"PERMISSION DENIED","Sorry, you have no user edit permission. Contact system admin for more info.","OK") 
                } else { 
                    this.MBS.actions.dialog(null,true,true,"DELETE USER LOCATION",'Are you sure you want to delete this location','CANCEL',"DELETE",{
                        code:pageName+"=CONFIRM-DELETE-USER-LOCATION",
                        observer:location
                    })   
                } 
            },

            //Heades
            headers(type){
                let hds = null
                if (type === 'user') {
                    hds = this.xHeader_user
                }else if (type === 'excel'){
                    hds = this.xHeader_user
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },
            setAutoCode(name){ 
                 let code = 0
                if (name==="location") {
                    code = this.not.CODE_GET_LAST(this.observerLocation) 
                } else {
                    let code = this.not.CODE_GET_LAST(this.uds) 
                }
                
                this.inputCode= (code+1 )
                this.MBS.actions.dialog(null,true,true,'GENERATED',"Code, successfully generated.","OK")  
            },
            isAutoCode(number){ 
                let code = this.not.CODE_GET_LAST(this.uds)
                if ((code+1 )=== number) {
                    return true
                }
                return false
            }, 
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/users'
                        })
                        let creating = ps.find(process=>{
                            return process.name == 'creating/user'
                        }) 
                        let editing = ps.find(process=>{
                            return process.name == 'editing/user'
                        }) 
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/user'
                        }) 

                        if (logging) {
                            this.page_show =false
                            // this.not.notDialogP(true,true,'Loading...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting) {
                            this.page_show_users =false
                            // this.not.notDialogP(true,false,'Loading...')
                        }else{
                            this.page_show_users =true
                        }

                        // if (creating) {
                        //     this.not.notDialogP(true,true,'Saving...')
                        //     this.input.loading = true
                        // }else{ 
                        // }  
                        // if (editing) {
                        //     this.not.notDialogP(true,true,'Saving...')
                        //     this.input.loading = true
                        // }else{ 
                        // }  
                        // if (deleting) {
                        //     this.not.notDialogP(true,true,'Deleting...') 
                        // }else{ 
                        // }  
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false) 
                    }

                    //check response
                     

                    

                     
 
                },t)
            },

            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===pageName+'=CREATE-USER') {
                            if (action.YES) { 
                                setTimeout(() => { 
                                    this.input_loading = true
                                    this.input.loading = true
                                    this.MBS.actions.progressDialog({
                                        show:true,
                                        title:"Creating.."
                                    })
                                    this.$store.dispatch("fi_createUserWithEmail",action.details)
                                    .then(res=>{
                                        this.input_loading = false
                                        this.input.loading = false 
                                        this.MBS.actions.dialog(null,true,true,'Successful','successfully created.','','OK')
                                        this.input.loading = false
                                        this.MBS.actions.progressDialog() 
                                        this.MBS.actions.restartResponses() 
                                        this.dialog_add_user = false
                                    }).catch(error=>{
                                        this.MBS.actions.dialog(null,true,true,'Not Successful','Error while creating the user ('+error.message
                                        +")",'','OK', )
                                        this.input_loading = false
                                        this.input.loading = false
                                        this.MBS.actions.progressDialog() 
                                        this.MBS.actions.restartResponses() 
                                    })
                                }, ACTION_TIME); 
                            } 
                        } 
                        if (action.code ===pageName+'=EDIT-USER') {
                            if (action.YES) { 
                                setTimeout(() => {  
                                    this.input_loading = true
                                    this.input.loading = true
                                    this.MBS.actions.progressDialog({
                                        show:true,
                                        title:"Updating.."
                                    })
                                    this.$store.dispatch("fi_update",{ 
                                        action:"user",
                                        path:DATA.PATHS.users+action.user.uid,
                                        data:{
                                            surname:action.user.surname,
                                            names:action.user.names,
                                            name:action.user.surname+" "+action.user.names,
                                            user_group_code:action.user.user_group_code,
                                            phone:action.user.phone,
                                        }
                                    })
                                    .then(res=>{
                                        this.input_loading = false
                                        this.input.loading = false 
                                        this.MBS.actions.dialog(null,true,true,'Successful','successfully updating.','','OK') 
                                        this.MBS.actions.progressDialog() 
                                        this.MBS.actions.restartResponses() 
                                        this.dialog_edit_user = false
                                    }).catch(error=>{
                                        this.MBS.actions.dialog(null,true,true,'Not Successful','Error while updating the user ('+error.error_message
                                        +")",'','OK', )
                                        this.input_loading = false
                                        this.input.loading = false
                                        this.MBS.actions.progressDialog() 
                                        this.MBS.actions.restartResponses() 
                                    })
                                }, ACTION_TIME);  
                            } 
                        } 
                        if (action.code ===pageName+'=ADD-USER-LOCATION') {
                            if (action.YES) {  
                                setTimeout(() => {
                                    this.input.loading = true 
                                    this.$store.dispatch("fi_add",{
                                        action:"userLocation",
                                        path:"/SETTINGS/USER_LOCATION/",
                                        data:action.details,
                                        us:this.us
                                    }) 
                                }, ACTION_TIME);
                                
                            } 
                        } 
                        if (action.code ===pageName+'=CONFIRM-DELETE-USER-LOCATION') {
                            if (action.YES) {  
                                setTimeout(() => { 
                                    this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting this location","CANCEL","CONFIRM",{
                                        ...action,
                                        code:pageName+"=DELETE-USER-LOCATION",
                                    }) 
                                }, ACTION_TIME);
                            }  
                        }
                        if (action.code ===pageName+'=DELETE-USER-LOCATION') {
                            if (action.YES) {   
                                setTimeout(() => { 
                                    let password = action.password
                                    if (password!==this.ud.password) {
                                        this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered","OK")
                                    } else {
                                        this.$store.dispatch("fi_delete",{
                                            action:"observer",
                                            path:"/SETTINGS/USER_LOCATION/"+action.observer.key+"/"
                                        })    
                                    } 
                                }, ACTION_TIME);  
                            }     
                        } 
                        if (action.code ===pageName+'=CREATE-USER-SUCCESS') {
                            this.dialog_add_user = false
                        }
                        if (action.code ===pageName+'=EDIT-USER-SUCCESS') {
                            this.dialog_edit_user = false
                        }  
                        if (action.code ===pageName+'=CONFIRM-DELETE-USER') {
                            if (action.YES) {  
                                setTimeout(() => { 
                                    this.MBS.actions.dialogInput({
                                        show:true,
                                        fixed:true,
                                        title:"CONFIRM",
                                        text:"Enter your password to confirm deleting this USER",btnNo:"CANCEL",
                                        btnYes:"CONFIRM",
                                        field:[
                                            {field:"password",label:'Password',type:'password'}
                                        ],
                                        action:{
                                            ...action,
                                            code:pageName+"=DELETE-USER",
                                        }
                                    })   
                                }, ACTION_TIME);
                            }  
                        } 
                        
                        if (action.code ===pageName+'=DELETE-USER') {
                            let password = this.MBS.crypt.encrypt(action.password) 
                            if (password!==this.ud.p_uid) {
                                this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered","OK")
                            } else {      
                                this.input.loading = true 
                                this.input_loading = true 
                                this.MBS.actions.progressDialog({
                                    show:true,
                                    title:"Deleting.."
                                })
                                this.$store.dispatch("DELETE_USER",action.user) 
                                .then(res=>{
                                    console.log(res,11111);
                                    this.input.loading = false 
                                    this.input_loading = false 
                                    this.MBS.actions.dialog(null,true,true,'Successful','successfully deleted.','','OK') 
                                    this.MBS.actions.progressDialog() 
                                    this.MBS.actions.restartResponses() 
                                }).catch(error=>{
                                    console.log(error,2222222);
                                    this.input.loading = false 
                                    this.input_loading = false 
                                    this.MBS.actions.dialog(null,true,true,'Not Successful','Error while deleting the user ('+error.error_message
                                        +")",'','OK', )
                                    this.MBS.actions.progressDialog() 
                                    this.MBS.actions.restartResponses()
                                })
                            }
                            
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
        }, 
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);   
        },
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
